import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { EvrideoCommonModule } from '../common/evrideo-common.module';

// Components
import { PublishingStatusContainerComponent } from './publishing-status-container/publishing-status-container.component';
import { PublishingToolbarComponent } from './publishing-toolbar/publishing-toolbar.component';
import { PublishingGridComponent } from './publishing-grid/publishing-grid.component';
import { PublishingEventCardComponent } from './publishing-event-card/publishing-event-card.component';
import { PublishingPaginationFooterComponent } from './publishing-pagination-footer/publishing-pagination-footer.component';

/**
 * Loaded via ClippingStudioModule so EvrideoCommonModule is not imported twice (avoids NG05100).
 * List view route: /clipping-studio (empty child in clipping-studio.routes.ts).
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InlineSVGModule.forRoot(),
    EvrideoCommonModule,
  ],
  declarations: [
    PublishingStatusContainerComponent,
    PublishingToolbarComponent,
    PublishingGridComponent,
    PublishingEventCardComponent,
    PublishingPaginationFooterComponent,
  ],
  exports: [PublishingStatusContainerComponent],
})
export class PublishingStatusModule {}
